import React from 'react';
import { ExternalLink, ArrowRight } from 'lucide-react';

// Obtener versión dinámicamente
const getAppVersion = () => {
  // Formato DD.MM.YYYY más intuitivo
  try {
    return process.env.npm_package_version || 
           `${String(new Date().getDate()).padStart(2, '0')}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${new Date().getFullYear()}`;
  } catch {
    return `${String(new Date().getDate()).padStart(2, '0')}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${new Date().getFullYear()}`;
  }
};

export const Footer: React.FC = () => {
  const appVersion = getAppVersion();

  return (
    <footer className="w-full bg-card/30 backdrop-blur-xl border-t border-border/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Links superiores - Estilo Apple minimalista */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs">
            <a
              href="/modularis"
              className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              Modularis
            </a>
            <a
              href="https://www.modularis.pro"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              www.modularis.pro
            </a>
            <a
              href="https://www.juliochicas.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              Ingeniero Julio Chicas
            </a>
          </div>

          {/* Copyright y versión - Diseño minimalista */}
          <div className="flex flex-col sm:flex-row items-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
            <p>© {new Date().getFullYear()} modularis.pro. Todos los derechos reservados.</p>
            <span className="hidden sm:inline text-border">|</span>
            <div className="flex items-center space-x-2">
              <div className="h-1.5 w-1.5 bg-success rounded-full animate-pulse"></div>
              <span>v{appVersion}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};